import { useMutation } from '@apollo/client';
import { Button, Modal } from 'antd';
import React from 'react';
import { UPDATE_INSTRUCTION_TYPE } from '../graphql/Mutation';

const EnableDisableModal = ({
  showModal,
  setShowModal,
  handleRefetch,
  selectedTree,
}) => {
  const handleCancel = () => {
    setShowModal(false);
  };

  const [updateInstructionType, { loading }] = useMutation(
    UPDATE_INSTRUCTION_TYPE,
    {
      onCompleted() {
        handleCancel();
        handleRefetch();
      },
      onError() {},
    },
  );

  const handleClick = () => {
    updateInstructionType({
      variables: {
        id: selectedTree?.id,
        data: {
          isActive: !selectedTree?.isActive,
        },
      },
    });
  };
  return (
    <div id="delete-levels">
      <Modal
        maskClosable={false}
        centered
        open={showModal}
        footer={null}
        closable={false}
        width={420}
        getContainer={() =>
          // eslint-disable-next-line no-undef
          document.getElementById('delete-levels')
        }
      >
        <div>
          <h2>{!selectedTree?.isActive ? `Enable` : `Disable`} level</h2>
          <>
            <p>Hey there! </p>
            <p>
              This will {!selectedTree?.isActive ? `enable` : `disable`} "
              {selectedTree?.name}"
            </p>
          </>
          <div className="form-buttons">
            <Button
              shape="round"
              className="cancel-button"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              shape="round"
              type="primary"
              className="save-button"
              onClick={handleClick}
              disabled={loading}
              loading={loading}
            >
              {!selectedTree?.isActive ? `Enable` : `Disable`}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EnableDisableModal;
